import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const translations = {
  es: {
    // Navegación
    dashboard: 'Dashboard',
    clients: 'Clientes',
    sessionValidation: 'Validación de Sesiones',
    apps: 'Apps',
    consumerExperience: 'Consumer Experience',
    staffAmplifier: 'Staff Amplifier',
    kitchenMatrix: 'Kitchen Matrix',
    mixologyLab: 'Mixology Lab',
    rewards: 'Recompensas',
    reviews: 'Reviews',
    aiAgents: 'Agentes IA',
    marketingCenter: 'Centro IA Marketing',
    billing: 'Facturación',
    restaurantConfig: 'Configuración',
    collaborators: 'Colaboradores',
    roiViewer: 'ROI Viewer',
    integrations: 'Integraciones',
    
    // Top Navbar
    poweredBy: 'Powered by KumIA Technology',
    user: 'Usuario',
    logout: 'Cerrar Sesión',
    roi: 'ROI',
    hours: 'horas',
    
    // Dashboard
    dashboardTitle: 'Dashboard General',
    dashboardSubtitle: 'Resumen ejecutivo de tu impacto KumIA',
    weeklyReport: 'Reporte Semanal',
    economicImpact: 'Impacto Económico',
    customerEngagement: 'Compromiso del Cliente',
    brandImpact: 'Impacto de Marca',
    quickActions: 'Acciones Rápidas',
    validateSessions: 'Validar Sesiones',
    manageMenu: 'Gestionar menú y recompensas',
    viewAnalytics: 'Ver análisis detallado ROI',
    
    // Métricas comunes
    vsLastMonth: 'vs mes anterior',
    loading: 'Cargando',
    save: 'Guardar',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Eliminar',
    view: 'Ver',
    search: 'Buscar',
    filter: 'Filtrar',
    export: 'Exportar',
    import: 'Importar',
    
    // Login
    loginTitle: 'KumIA',
    loginSubtitle: 'Ecosistema gastronómico inteligente que transforma experiencias en capital, fidelidad cuantificable y crecimiento sostenido.',
    loginWelcome: 'Bienvenido al Business Command Center Dashboard',
    googleLogin: 'Iniciar sesión con Google',
    continueWith: 'O continúa con credenciales',
    email: 'Email',
    password: 'Contraseña',
    login: 'Iniciar Sesión',
    loggingIn: 'Iniciando sesión...',
  },
  
  en: {
    // Navigation
    dashboard: 'Dashboard',
    clients: 'Clients',
    sessionValidation: 'Session Validation',
    apps: 'Apps',
    consumerExperience: 'Consumer Experience',
    staffAmplifier: 'Staff Amplifier',
    kitchenMatrix: 'Kitchen Matrix',
    mixologyLab: 'Mixology Lab',
    rewards: 'Rewards',
    reviews: 'Reviews',
    aiAgents: 'AI Agents',
    marketingCenter: 'AI Marketing Center',
    billing: 'Billing',
    restaurantConfig: 'Settings',
    collaborators: 'Collaborators',
    roiViewer: 'ROI Viewer',
    integrations: 'Integrations',
    
    // Top Navbar
    poweredBy: 'Powered by KumIA Technology',
    user: 'User',
    logout: 'Logout',
    roi: 'ROI',
    hours: 'hours',
    
    // Dashboard
    dashboardTitle: 'General Dashboard',
    dashboardSubtitle: 'Executive summary of your KumIA impact',
    weeklyReport: 'Weekly Report',
    economicImpact: 'Economic Impact',
    customerEngagement: 'Customer Engagement',
    brandImpact: 'Brand Impact',
    quickActions: 'Quick Actions',
    validateSessions: 'Validate Sessions',
    manageMenu: 'Manage menu and rewards',
    viewAnalytics: 'View detailed ROI analysis',
    
    // Common metrics
    vsLastMonth: 'vs last month',
    loading: 'Loading',
    save: 'Save',
    cancel: 'Cancel',
    edit: 'Edit',
    delete: 'Delete',
    view: 'View',
    search: 'Search',
    filter: 'Filter',
    export: 'Export',
    import: 'Import',
    
    // Login
    loginTitle: 'KumIA',
    loginSubtitle: 'Intelligent gastronomic ecosystem that transforms experiences into capital, quantifiable loyalty and sustained growth.',
    loginWelcome: 'Welcome to the Business Command Center Dashboard',
    googleLogin: 'Sign in with Google',
    continueWith: 'Or continue with credentials',
    email: 'Email',
    password: 'Password',
    login: 'Login',
    loggingIn: 'Logging in...',
  },
  
  pt: {
    // Navigation
    dashboard: 'Dashboard',
    clients: 'Clientes',
    sessionValidation: 'Validação de Sessões',
    apps: 'Apps',
    consumerExperience: 'Experiência do Consumidor',
    staffAmplifier: 'Amplificador de Equipe',
    kitchenMatrix: 'Matrix da Cozinha',
    mixologyLab: 'Lab de Mixologia',
    rewards: 'Recompensas',
    reviews: 'Avaliações',
    aiAgents: 'Agentes IA',
    marketingCenter: 'Centro de Marketing IA',
    billing: 'Faturamento',
    restaurantConfig: 'Configurações',
    collaborators: 'Colaboradores',
    roiViewer: 'Visualizador ROI',
    integrations: 'Integrações',
    
    // Top Navbar
    poweredBy: 'Powered by KumIA Technology',
    user: 'Usuário',
    logout: 'Sair',
    roi: 'ROI',
    hours: 'horas',
    
    // Dashboard
    dashboardTitle: 'Dashboard Geral',
    dashboardSubtitle: 'Resumo executivo do seu impacto KumIA',
    weeklyReport: 'Relatório Semanal',
    economicImpact: 'Impacto Econômico',
    customerEngagement: 'Engajamento do Cliente',
    brandImpact: 'Impacto da Marca',
    quickActions: 'Ações Rápidas',
    validateSessions: 'Validar Sessões',
    manageMenu: 'Gerenciar menu e recompensas',
    viewAnalytics: 'Ver análise detalhada do ROI',
    
    // Common metrics
    vsLastMonth: 'vs mês anterior',
    loading: 'Carregando',
    save: 'Salvar',
    cancel: 'Cancelar',
    edit: 'Editar',
    delete: 'Excluir',
    view: 'Ver',
    search: 'Pesquisar',
    filter: 'Filtrar',
    export: 'Exportar',
    import: 'Importar',
    
    // Login
    loginTitle: 'KumIA',
    loginSubtitle: 'Ecossistema gastronômico inteligente que transforma experiências em capital, fidelidade quantificável e crescimento sustentado.',
    loginWelcome: 'Bem-vindo ao Business Command Center Dashboard',
    googleLogin: 'Entrar com Google',
    continueWith: 'Ou continue com credenciais',
    email: 'Email',
    password: 'Senha',
    login: 'Entrar',
    loggingIn: 'Entrando...',
  }
};

export const useLanguageStore = create(
  persist(
    (set, get) => ({
      currentLanguage: 'es',
      translations,
      
      setLanguage: (language) => {
        set({ currentLanguage: language });
      },
      
      t: (key, fallback = key) => {
        const { currentLanguage, translations } = get();
        return translations[currentLanguage]?.[key] || translations['es']?.[key] || fallback;
      },
      
      getCurrentTranslations: () => {
        const { currentLanguage, translations } = get();
        return translations[currentLanguage] || translations['es'];
      }
    }),
    {
      name: 'kumia-language-storage',
      partialize: (state) => ({ currentLanguage: state.currentLanguage }),
    }
  )
);